export default "__VITE_ASSET__DTduQh2U__"